module.exports = __webpack_public_path__ + "img/bg-signed.74929fd8.png";